import { render, staticRenderFns } from "./VCompaniesBrowse.vue?vue&type=template&id=6b0b1bdd&scoped=true&lang=pug"
import script from "./VCompaniesBrowse.vue?vue&type=script&lang=ts"
export * from "./VCompaniesBrowse.vue?vue&type=script&lang=ts"
import style0 from "./VCompaniesBrowse.vue?vue&type=style&index=0&id=6b0b1bdd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b1bdd",
  null
  
)

/* custom blocks */
import block0 from "./VCompaniesBrowse.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FExpert%2Fviews%2FCompanies%2Fbrowse%2FVCompaniesBrowse.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports